/**
 * WhatsApp 服务端 -> 前端 事件类型
 * 与 wecom 的 WS_RESPONSE_MESSAGE_TYPE 存在差异（登录二维码 11000、联系人详情 2001），
 * 因此单独定义，避免混用。
 */
export enum WHATSAPP_WS_RESPONSE_TYPE {
  /** 应用关闭通知 */
  CLIENT_CLOSE = 10002,
  /** 接收二维码（login_qrcode_path 为扫码字符串，需前端生成二维码） */
  RECEIVE_LOGIN_QRCODE = 11000,
  /** 登录成功通知 */
  LOGIN_SUCCESS = 11001,
  /** 登出通知 */
  LOGIN_OUT = 11002,
  /** 接收消息 */
  RECEIVE_MESSAGE = 15000,
  /** 其他终端发送消息 */
  OTHER_TERMINAL_RECEIVE_MESSAGE = 15001,
  /** 文件下载成功通知 */
  FILE_DOWNLOAD_SUCCESS_NOTICE = 18006,
  /** 获取联系人详情 */
  GET_CONTACT_DETAIL = 2001,
  /** 会话变更通知 */
  CONVERSATION_CHANGE = 120002,
  /** 未读数更新 */
  UNREAD_NUM_UPDATE = 120001,
  /** 错误 */
  ERROR = 99999,
}

/**
 * WhatsApp 前端 -> 服务端 请求类型
 */
export enum WHATSAPP_WS_REQUEST_TYPE {
  /** 打开客户端（登录取二维码） */
  OPEN = 1,
  /** 下线账号 */
  DOWNLINE = 2,
  /** 查询历史消息 */
  GET_HISTORY_MESSAGE = 5303,
  /** 发送文本 */
  SEND_TEXT = 5000,
  /** 发送图片 */
  SEND_IMAGE = 5003,
  /** 发送文件 */
  SEND_FILE = 5005,
  /** 修改会话状态 */
  UPDATE_CONVERSATION_STATUS = 20003,
}

/**
 * 登录二维码数据。
 * login_qrcode_path 为 WhatsApp 扫码字符串（如 `2@...`），不是 base64 图片，
 * 前端需用 QRCode 组件编码后展示。
 */
export interface WhatsAppReceiveLoginQRCodeData {
  login_qrcode_path: string;
  login_qrcode_key?: string;
  request_key?: string;
  ip?: string;
  client_id?: number;
  /** 后端实际字段（camelCase） */
  clientId?: number;
}

export interface WhatsAppLoginSuccessData {
  user_id: string;
  name?: string;
  avatar?: string;
  mobile?: string;
}

export type WhatsAppUnreadNumUpdateData = {
  userId: string;
  unread: number;
};

export type WhatsAppErrorData = {
  error_msg: string;
};
